// BaseModal.jsx
import React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import { IconX } from '@tabler/icons-react';
import Logo from '../../resources/images/logo/bizismart.png';
import { StringKeys } from '../../resources/strings/StringKeys';
import { useTranslation } from 'react-i18next';

const BaseModal = ({ open, onClose, title, children, actions, maxWidth = "md" }) => {

    const { t } = useTranslation();

    return (
        <Dialog open={open} onClose={onClose} maxWidth={maxWidth} fullWidth>
            <DialogTitle>
                <img src={Logo} alt="logo" style={{ height: '30px', marginRight:"20px" }} />
                {title}
                <IconButton
                    aria-label={t(StringKeys.CLOSE)}
                    onClick={onClose}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <IconX />
                </IconButton>
            </DialogTitle>
            <DialogContent dividers>
                {children}
            </DialogContent>
            <DialogActions>
                {actions}
            </DialogActions>
        </Dialog>
    );
};

export default BaseModal;